<template>
  <div>
    <el-dialog :close-on-click-modal="false" title="Select Smith" v-if="visible" :model-value="visible"
      @update:modelValue="(val) => { if (!val) modal.closeSmith(); visible = val }" width="50%">
      <el-input v-model="searchQuery" placeholder="Search smith name" @input="handleSearchInput"
        style="margin-bottom: 20px" />
      <el-button size="small" type="primary" style="margin-bottom: 10px" @click="handleSmithAdd">Add New</el-button>
      <el-table :data="smithList" @row-click="handleSelect" stripe v-loading="listLoading"
        header-cell-class-name="my-header">
        <el-table-column prop="name" label="Smith Name" />
        <el-table-column label="" align="right">
          <template #default="scope">
            <el-button v-if="scope" size="small" type="primary" @click.stop="handleSelect(scope.row)">Select</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <el-button @click="modal.closeSmith(); visible = false">Cancel</el-button>
      </template>
    </el-dialog>

    <SmithFormDialog v-model:visible="addVisible" :row="null" @saved="handleSmithSaved" />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { debounce } from 'lodash'
import { fetchList as fetchSmithList } from '@/api/smith'
import { useFetch } from '@/composables/useFetch'
import { useModalStore } from '@/stores/modal'
import SmithFormDialog from '@/views/production/smith/components/SmithFormDialog.vue'

const modal = useModalStore()

const visible = ref(false)
const addVisible = ref(false)
const searchQuery = ref('')

const { data: smithList, loading: listLoading, fetch: fetchSmiths } = useFetch(
  () => fetchSmithList({ keyword: searchQuery.value }),
  { extract: res => res.data.list || [], defaultValue: [] }
)

watch(() => modal.smith.visible, async (val) => {
  if (val) {
    searchQuery.value = ''
    visible.value = true
    await fetchSmiths()
  } else {
    visible.value = false
  }
}, { immediate: true })

const handleSearchInput = debounce(() => {
  fetchSmiths()
}, 300)

function handleSelect(row) {
  modal.resolveSmith(row)
}

function handleSmithAdd() {
  addVisible.value = true
}

async function handleSmithSaved() {
  await fetchSmiths()
}
</script>

<style scoped>
.my-header {
  font-weight: bold;
}
</style>
